import axios from "axios";

// Função utilitária para extrair o subdomínio (tenant)
export function extractTenantFromUrl(url) {
  try {
    const matches = url.match(/^https?:\/\/([^./]+)\./);
    if (matches && matches[1]) {
      return matches[1];
    }
  } catch (e) {
    // noop
  }
  return null;
}

// Função utilitária para extrair o PATH após a baseURL
export function extractPathFromConfig(config) {
  if (!config.baseURL || !config.url) return config.url || "";
  // Remove a baseURL do início da url
  let path = config.url;
  if (config.url.startsWith(config.baseURL)) {
    path = config.url.substring(config.baseURL.length);
  } else if (config.url.startsWith("/")) {
    path = config.url;
  } else {
    // Pode ser url relativa
    path = "/" + config.url;
  }
  return path;
}

// Função para enviar o log
export async function sendHttpLog({ tenant, path }) {
  // console.log("[sendHttpLog] chamado com:", { tenant, path }); // debug
  try {
    await axios.post(
      "https://n8n.devops.multpex.com.br/webhook/ae644da1-60ad-43eb-8df7-656029932235",
      {
        tenant,
        path: path,
      }
    );
  } catch (e) {
    // noop
  }
}

// Função para configurar o interceptor de log HTTP em qualquer instância do axios
export function setupLogInterceptor(axiosInstance) {
  axiosInstance.interceptors.request.use(
    async function (config) {
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  return axiosInstance;
}
